module.exports = __webpack_public_path__ + "img/PICTO_LIGNE_VIOLET.6f7aa413.svg";